import React, { useState, useRef, useEffect } from 'react';
import authApi from '../services/auth';

export default function TwoFactorVerify({ tempToken, onSuccess, onBack }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleCodeChange = async (value) => {
    const digits = value.replace(/[^0-9]/g, '').slice(0, 6);
    setCode(digits);
    setError('');

    if (digits.length === 6) {
      setLoading(true);
      try {
        const res = await authApi.verify2fa(tempToken, digits);
        onSuccess(res.data.user, res.data.token);
      } catch (err) {
        setError(err.response?.data?.error || 'Code incorrect ou expire');
        setCode('');
        setLoading(false);
        setTimeout(() => inputRef.current?.focus(), 50);
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-card" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <div className="login-icon">🔐</div>
        <h1>Verification en deux etapes</h1>
        <p className="login-subtitle">
          Entrez le code a 6 chiffres affiche dans<br />
          <strong>Microsoft Authenticator</strong>
        </p>

        <input
          ref={inputRef}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          value={code}
          onChange={e => handleCodeChange(e.target.value)}
          placeholder="000000"
          disabled={loading}
          style={{
            width: '100%', padding: '16px', fontSize: '32px', fontWeight: '700',
            textAlign: 'center', letterSpacing: '12px',
            border: `2px solid ${error ? '#ef4444' : code.length === 6 ? '#10b981' : '#d1d5db'}`,
            borderRadius: '8px', outline: 'none', boxSizing: 'border-box',
            background: loading ? '#f8fafc' : '#fff',
          }}
          autoComplete="one-time-code"
        />

        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '12px', marginBottom: '14px' }}>
          {[0,1,2,3,4,5].map(i => (
            <div key={i} style={{
              width: '8px', height: '8px', borderRadius: '50%',
              background: i < code.length ? '#3b82f6' : '#d1d5db',
              transition: 'background 0.15s',
            }} />
          ))}
        </div>

        {error && (
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px',
            padding: '8px 12px', color: '#ef4444', fontSize: '0.82rem', marginBottom: '14px',
            textAlign: 'left',
          }}>
            {error}
          </div>
        )}

        {loading && <p style={{ color: '#94a3b8', fontSize: '0.82rem', margin: '0 0 14px' }}>Verification en cours...</p>}

        <button type="button" onClick={onBack} disabled={loading}
          style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '0.8rem', cursor: 'pointer', textDecoration: 'underline' }}>
          Changer de compte
        </button>

        <p style={{ fontSize: '0.7rem', color: '#94a3b8', marginTop: '16px', lineHeight: '1.5' }}>
          Le code se renouvelle toutes les 30 secondes.<br />
          Compatible avec Google Authenticator, Authy et toute app TOTP.
        </p>
      </div>
    </div>
  );
}
